module.exports = __webpack_public_path__ + "img/1505666861.cc37218d.jpg";